<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1" v-for="(item, i) in category" :key="i" >
                <v-card-title>
                  <v-flex xs6 sm6 md6 class="text-left">{{ item.name }}</v-flex>
                  <v-flex xs6 sm6 md6 class="text-right">
                    <v-dialog v-model="item.addDialogbox" max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="primary"
                          @click="addImage(item)"
                        >
                          mdi-plus
                        </v-icon>
                      </template>

                      <v-card>
                        <v-form v-model="formCategory" ref="formCategory">
                          <v-card-title>
                            <span v-if="edit == false" class="headline"
                              >Add Images</span
                            >
                            <span v-else class="headline">Edit Image</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  class="text-center"
                                >
                                  <img
                                    :src="imagePreview"
                                    class="role active"
                                    style="width: 150px; height: 150px"
                                  />
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                  <v-file-input
                                    v-model="categoryImg"
                                    @change="getFiles"
                                    ref="files"
                                    multiple
                                    label="Image"
                                    outlined
                                    dense
                                  ></v-file-input>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="red darken-1"
                              text
                              @click="item.addDialogbox = false"
                            >
                              Close
                            </v-btn>
                            <v-btn
                              v-if="edit == false"
                              color="blue darken-1"
                              text
                              :disabled="!formCategory"
                              @click="uploadattachments()"
                            >
                              Save
                            </v-btn>
                            <v-btn
                              v-else
                              color="blue darken-1"
                              text
                              :disabled="!formCategory"
                              @click="categoryEdit()"
                            >
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-form>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-card-title>
                <v-card-text v-if="item.sliderImages.length > 0">
                  <v-row style="padding-left: 18px">
                    <v-col
                      md="3"
                      sm="3"
                      xs="3"
                      v-for="(i, index) in item.sliderImages"
                      :key="index"
                    >
                      <v-row>
                        <v-col md="6" sm="6" xs="6">
                          <img
                            class="role active"
                            v-bind:src="baseURL + '/file/get/' + i"
                            style="width: 230px; height: 200px"
                          />
                        </v-col>
                        <v-col md="3" sm="3" xs="3" >
                          <v-icon
                            style="padding-left: 94px;"
                            @click="appdelete(i, item)"
                            >mdi-close-circle</v-icon
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      headers: [
        { text: "Icon", value: "icon", sortable: false },
        { text: "Category", value: "name" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      edit: false,
      editId: "",
      dialog: false,
      addDialogbox: false,
      addDialog: false,
      editdialog: false,
      deleteCategory: false,
      formCategory: false,
      categoryId: null,
      category: [],
      categoryImg: null,
      imagePreview: null,
      attachments: [],
      selectedFiles: null,
      attachmentsformData: new FormData(),
      editingitem: [],
      name: "",
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 20,
      page: 1,
      totalpages: 0,
      ItemsCount: [20, 30, 50, 100],
      msg: "",
      showsnackbar: false,
      timeout: 3000,
    };
  },
  beforeMount() {
    this.getCategory();
  },
  watch: {
    itemsPerPage: function () {
      this.getCategory();
    },
  },
  methods: {
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getCategory();
        // } else {
        //   this.page--;
        //   this.getcategory();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getCategory();
        // } else {
        //   this.page++;
        //   this.getcategory();
        // }
      }
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url:  "/subcategory/list/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          limit: this.itemsPerPage,
          page: this.page,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.category = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );

          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },

    

    addImage(item) {
      (this.categoryId = item._id), (this.addDialogbox = true);
    },

   

    
   
    getFiles() {
      if (this.attachments.length < 4) {
        this.selectedFiles = this.categoryImg[0];
        // this.Images.append("image", this.selectedFiles);
        this.attachmentsformData.append("images", this.selectedFiles);
        const urls = URL.createObjectURL(this.selectedFiles);
        this.imagePreview = urls;
        if (this.attachments.length < 4) {
          this.attachments.push(urls);
        }
      } else {
        this.msg = "Maximum image limit exceeded!";
        this.showSnackBar = true;

        return;
      }
    },

    uploadattachments() {
      // var url = "";
      // if (this.editId) url = "/category/upload/icon/" + this.editId;
      // else url = "/category/upload/icon/" + this.cId;
      this.categoryImg = null;
      // this.attachmentsformData.append("images", this.attachments);
      axios({
        method: "POST",
        url: "/subcategory/upload/sliderimages/" + this.categoryId,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },

        data: this.attachmentsformData,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          //this.appLoading = true;
          // vm.uploadMsg = "Uploading " + percentCompleted + "%";
          if (percentCompleted == 100) {
            // this.appLoading = false;
          }
        },
      })
        .then((response) => {
          if (response.status) {
            this.appLoading = false;
            this.getCategory();
            this.attachmentsformData = new FormData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    appdelete(index, item) {
      var data = {};

      data["key"] = [index];
      axios({
        method: "POST",
        url: "/subcategory/sliderimages/delete/" + item._id,
        data: data,
        headers: {
          "token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          // console.log(response)

          this.msg = " Deleted Image";
          this.getCategory();
          this.showsnackbar = true;
        }
      });
    },
    
  },
};
</script>
<style >
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>



